// 添加原料
<template>
  <a-modal :visible="visible.batchAddRaw" @ok="ok" :bodyStyle="{ padding: '10px 20px' }" :destroyOnClose="true"
    :forceRender="true" @cancel="cancel" width="900px">
    <span class="title" slot="title">批量添加原料 <b>在选中的配方中添加原料
      </b></span>
    <div class="raw-model-info-row">已选中配方：<span>{{ formulaSelectedRows.map(item => `【${item.formulaName}】`).join(',')
        }}</span></div>
    <div class="raw-model-info-row">可添加原料明细：</div>
    <a-spin :spinning="addLoading">
      <a-button type="primary" style="margin-bottom: 2em;width: 5em;" @click="showImportMaterial">导入</a-button>
      <a-table :columns="columns" bordered :scroll="{ x: 870, y: 450 }" :data-source="list.records"
        :row-key="(record) => record.id" :pagination="false">

        <template slot="name" slot-scope="text, record">
          {{ overseasFlag == "1" ? record.aliasName || text : text }}
        </template>
        <template v-for="col in ['minValue', 'maxValue']" :slot="col" slot-scope="text, record">
          <cell-editor :len="3" :item="record" :key="col" :name="col" :text="text"
            @blur="target => itemUpdate(target, record.id)" />
        </template>
        <template slot="option" slot-scope="text, record, index">
          <a-space>
            <a @click="deleteItem(index)" style="color: #ff4d4f;">删除</a>
          </a-space>
        </template>

      </a-table>
    </a-spin>

    <import-material :visible="visible.importMaterial" @ok="importModalOk"></import-material>
  </a-modal>
</template>
<script>
import { formulaMixins } from '../unitls';
import CellEditor from '../editor/CellEditor.vue';
import ImportMaterial from './ImportMaterial.vue';
export default {
  mixins: [formulaMixins],
  components: { CellEditor, ImportMaterial },
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      list: {},
      rawType: [],
      addLoading: false,
      columns: [
        {
          dataIndex: 'name',
          title: '原料名称',
          align: 'center',
          scopedSlots: { customRender: 'name' },
        },
        {
          dataIndex: 'code',
          align: 'center',
          title: '原料代码',
          width: 110
        },
        {
          title: '最小值',
          dataIndex: 'minValue',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'minValue' },
        },
        {
          title: "最大值",
          dataIndex: "maxValue",
          align: 'center',
          width: 120,
          scopedSlots: { customRender: "maxValue" },
        },
        {
          title: "操作",
          dataIndex: "option",
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'option' }
        },
      ],
    };
  },

  methods: {
    async batchAddRaw() {
      return this.fetchPost({
        actions: this.batchAddFormulaRawVal,
        loading: 'addLoading',
        data: {
          formulaTaskFormulaRawList: this.list.records.map(i => { return { rawId: i.rawId, minValue: i.minValue, maxValue: i.maxValue }; }),
          taskFormulaIdList: this.formulaSelectedRows.map(i => i.id),
          taskId: this.taskId
        }
      });
    },

    async ok() {
      if (this.list.records.length) {
        this.$confirm({
          title: '批量添加原料',
          content: '确定以已设定的最小值、最大值，将明细中的原料添加到配方中吗？',
          cancelText: '取消',
          okText: '确定',
          onOk: async () => {
            await this.batchAddRaw();
            this.toggleVisible('batchAddRaw');
            this.clear();
            this.$emit('ok');
          },
          onCancel() { },
        });

      } else
        this.$message.warn('选择需要添加的原料');
    },

    cancel() { 
      this.toggleVisible('batchAddRaw');
      this.clear();
    },

    clear() { 
      this.list = {};
    },

    showImportMaterial() {
      this.toggleVisible('batchAddRawImport');
    },

    importModalOk(data) {
      data.rows.forEach(item => {
        item.minValue = '';
        item.maxValue = '';
      });
      this.list.records = data.rows;
    },

    deleteItem(index) {
      let records = [...this.list.records];
      records.splice(index, 1);
      this.list.records = records;
      this.$forceUpdate();
    },

    itemUpdate(item, id) {
      const list = [...this.list.records];
      const targets = list.filter(item => id === item.id)[0];
      if (targets) {
        Object.assign(targets, item);
        this.list.records = list;
        this.$forceUpdate();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}

.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}
</style>
